import emailjs from "@emailjs/browser";

export const sendEmail = async (templateParams) => {
  const emailConfig = {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
    TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",
  };

  try {
    const response = await emailjs.send(
      emailConfig.SERVICE_ID,
      emailConfig.TEMPLATE_ID,
      templateParams,
      emailConfig.PUBLIC_KEY
    );
    return { success: true };
  } catch (error) {
    console.error("Error sending email:", error);
    return { success: false, error };
  }
};

export const sendDiscountEmail = async (templateParams) => {
  const emailConfig = {
    SERVICE_ID: process.env.REACT_APP_DISCOUNT_EMAILJS_SERVICE_ID || "",
    TEMPLATE_ID: process.env.REACT_APP_DISCOUNT_EMAILJS_TEMPLATE_ID || "",
    PUBLIC_KEY: process.env.REACT_APP_DISCOUNT_EMAILJS_PUBLIC_KEY || "",
  };

  try {
    const response = await emailjs.send(
      emailConfig.SERVICE_ID,
      emailConfig.TEMPLATE_ID,
      templateParams,
      emailConfig.PUBLIC_KEY
    );
    return { success: true };
  } catch (error) {
    console.error("Error sending discount email:", error);
    return { success: false, error };
  }
}